var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222326"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.963 5.853a6.11 6.11 0 1 0 0 12.22a6.11 6.11 0 0 0 0-12.22m-7.25 6.11a7.249 7.249 0 1 1 14.499 0a7.249 7.249 0 0 1-14.498 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.984 14.145a1.2 1.2 0 0 1-.082-.224a3 3 0 0 1-.059-.268a1.77 1.77 0 0 1-.973.54q-.229.05-.462.05a2.3 2.3 0 0 1-.745-.118a1.8 1.8 0 0 1-.578-.325a1.5 1.5 0 0 1-.38-.497a1.5 1.5 0 0 1-.136-.632q0-.832.618-1.285c.415-.305 1.033-.475 1.853-.475h.594v-.293a.803.803 0 0 0-.803-.823c-.275 0-.477.096-.603.216a.61.61 0 0 0-.19.472H9.686q0-.336.145-.638c.101-.201.246-.413.433-.566q.288-.228.696-.36q.413-.136.944-.136q.477 0 .885.117q.414.117.716.346q.3.228.472.578q.17.345.17.803v2.258q0 .424.054.7q.053.277.155.477v.083zm-.756-1.124c.19-.105.327-.245.404-.38v-.873h-.528c-.403 0-.93.043-1.115.465c-.116.258-.09.583.122.783c.316.293.783.19 1.117.005"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.c3c95a51441a0670440c129a3879b309.svg";
export { ForwardRef as ReactComponent };